import { Directive, HostListener, OnInit, ElementRef, Renderer2, Input } from '@angular/core';
import { State, userRole } from '@nrwl/rx-root-state';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import { SnackbarService } from '@nrwl/snackbar-services';
import { Roles } from '@nrwl/rx-models';

@Directive({
  selector: '[rxRoleGuard]',
})
export class RxRoleGuardDirective implements OnInit {
  private userRole$: Observable<Roles>;

  private rejectRoles: Roles[];
  private isRejectedRole = false;
  private userRole: Roles;

  @Input()
  public set rxRoleGuard(value: Roles[]) {
    this.rejectRoles = value;
  }

  @HostListener('click', ['$event'])
  public onClick(event) {
    if (this.isRejectedRole) {
      event.preventDefault();
      event.stopPropagation();
      this.showWarningMsg();
    }
  }

  constructor(
    private _store: Store<State>,
    private _snackbarService: SnackbarService,
    private el: ElementRef,
    public renderer: Renderer2,
  ) {
    this.userRole$ = this._store.pipe(select(userRole));
  }

  public ngOnInit() {
    this.userRole$.subscribe((role: any) => {
      if (role === null) return;

      this.userRole = role;
      this.isRejectedRole = this.rejectRoles.indexOf(role) !== -1;

      if (this.isRejectedRole) {
        this.disableChildrenElements();
      }
    });
  }

  private disableChildrenElements() {
    setTimeout(() => {
      for (let i = 0, length = this.el.nativeElement.children.length; i < length; i++) {
        const child = this.el.nativeElement.children[i];

        if (!child.classList.contains('disabled')) {
          this.renderer.addClass(child, 'disabled');
        }
      }
    });
  }

  private showWarningMsg() {
    let msg = '';
    switch (this.userRole) {
      case Roles.Employee: {
        msg =
          "Your account is labeled as 'User' status \
                        therefore you do not have access to this feature. \
                        Please contact your 'Administrator' because you will need \
                        'Manager' status or higher for access";
      }
    }

    if (msg) {
      this._snackbarService.warning(msg);
    }
  }
}
